import { Link } from "react-router-dom";
import { Card } from "@/components/ui/card";
import { HardHat, ArrowLeft } from "lucide-react";

export default function Terms() {
  return (
    <div className="min-h-screen bg-background">
      <header className="bg-navy text-white">
        <div className="max-w-4xl mx-auto px-4 md:px-8 h-16 flex items-center justify-between">
          <Link to="/" className="flex items-center gap-2.5">
            <div className="h-9 w-9 rounded-md bg-brandblue flex items-center justify-center"><HardHat className="h-5 w-5" strokeWidth={2.5} /></div>
            <div className="font-display font-bold text-lg">BuildTrack</div>
          </Link>
          <Link to="/register" className="text-sm text-slate-300 hover:text-white inline-flex items-center gap-1"><ArrowLeft className="h-4 w-4" /> Back</Link>
        </div>
      </header>
      <main className="max-w-4xl mx-auto px-4 md:px-8 py-8 md:py-12">
        <div className="text-xs font-semibold uppercase tracking-widest text-slate-500 mb-2">Legal</div>
        <h1 className="font-display text-3xl md:text-4xl font-bold text-slate-900 tracking-tight">Terms of service</h1>
        <p className="text-sm text-slate-500 mt-1.5">Last updated: February 2026</p>

        <Card className="mt-8 p-6 md:p-8 space-y-6 border border-border shadow-sm text-slate-700 text-sm leading-relaxed">
          <Section title="1. Acceptance">
            By creating a BuildTrack account you agree to these Terms. If you don&apos;t agree, don&apos;t use the service.
          </Section>
          <Section title="2. Your account">
            You&apos;re responsible for keeping your credentials safe. You must be at least 18 years old. One human = one account.
          </Section>
          <Section title="3. Your data">
            Projects, trades, payments and uploaded files remain yours. We store them so you can access them. Only you can see your projects — see Privacy for details.
          </Section>
          <Section title="4. Acceptable use">
            No illegal content, no reselling access to your account, no attempts to break, probe or overload the service.
          </Section>
          <Section title="5. Availability">
            BuildTrack is provided &quot;as is&quot;. We aim for high uptime but don&apos;t guarantee it. Back up critical business records independently.
          </Section>
          <Section title="6. Financial figures">
            Amounts in AUD. Numbers you enter are yours; we do not verify them. Use figures at your own risk when making commercial decisions.
          </Section>
          <Section title="7. Termination">
            You can close your account at any time. We may suspend accounts that violate these terms.
          </Section>
          <Section title="8. Contact">
            Questions? Email support@buildtrack.example.
          </Section>
        </Card>
      </main>
    </div>
  );
}

function Section({ title, children }) {
  return (
    <div>
      <h2 className="font-display text-lg font-semibold text-slate-900 mb-2">{title}</h2>
      <div className="text-slate-600">{children}</div>
    </div>
  );
}
